import {
    removeInstructorLocalStorage,
    removeStudentLocalStorage,
} from "@/components/Providers/JWTProvider.tsx";

export const closeFMWindow = (timeout = 5000): void => {
    removeStudentLocalStorage();
    removeInstructorLocalStorage();
    setTimeout(() => {
        window.FileMaker && window.FileMaker.PerformScript("getCloseWindow", "");
    }, timeout);
};

window.fmResetLocalStorage = () => {
    removeStudentLocalStorage();
    removeInstructorLocalStorage();
    window.FileMaker && window.FileMaker.PerformScriptWithOption("getCloseWindow", "", "2");
};

export const isInFileMaker = new Promise<boolean>(resolve => {
    let repeatCount = 0;
    const repeat = setInterval(() => {
        repeatCount++;
        if ("FileMaker" in window) {
            resolve(true);
            clearInterval(repeat);
        }
        if (repeatCount > 200) {
            clearInterval(repeat);
            resolve(false);
        }
    }, 50); //tick every second
});
